module.exports = __webpack_public_path__ + "img/panorama-flats-mobile.b6f29bd9.jpg";